import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, resolveDynamicComponent as _resolveDynamicComponent, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eda60da0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inner-tab" }

import projInfo from "data/projInfo.json";
import { GenericLayer, layers } from "game/layers";
import player from "game/player";
import { computed, toRef } from "vue";
import Layer from "./Layer.vue";
import Nav from "./Nav.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const tabs = toRef(player, "tabs");
const layerKeys = computed(() => Object.keys(layers));
const useHeader = projInfo.useHeader;

function gatherLayerProps(layer: GenericLayer) {
    const { display, minimized, minWidth, name, color, style, classes, minimizable, nodes } = layer;
    return { display, minimized, minWidth, name, color, style, classes, minimizable, nodes };
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tabs-container", { useHeader: _unref(useHeader) }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (tab, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "tab",
        ref_for: true,
        ref: `tab-${index}`
      }, [
        (index === 0 && !_unref(useHeader))
          ? (_openBlock(), _createBlock(Nav, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_1, [
          (_unref(layerKeys).includes(tab))
            ? (_openBlock(), _createBlock(Layer, _mergeProps({ key: 0 }, gatherLayerProps(_unref(layers)[tab]!), {
                index: index,
                tab: () => ((_ctx.$refs[`tab-${index}`] as HTMLElement[] | undefined)?.[0])
              }), null, 16, ["index", "tab"]))
            : (_openBlock(), _createBlock(_resolveDynamicComponent(tab), {
                key: 1,
                index: index
              }, null, 8, ["index"]))
        ])
      ]))
    }), 128))
  ], 2))
}
}

})